"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAutopay = exports.savePayment = exports.saveNewDraw = exports.saveAchAccount = exports.getUserLoanStatuses = exports.getTransactions = exports.getServicingDocuments = exports.getLoanStatus = exports.getDrawTotalMonthlyPayment = exports.getDrawEligibility = exports.getDrawEligibilities = exports.getAchAccounts = exports.downloadServicingDocument = exports.deleteAchAccount = exports.activateLoan = exports.UPDATE_AUTOPAY = exports.SAVE_PAYMENT = exports.SAVE_NEW_DRAW = exports.SAVE_ACH_ACCOUNT = exports.GET_USER_LOAN_STATUSES = exports.GET_TRANSACTIONS = exports.GET_SERVICING_DOCUMENTS = exports.GET_LOAN_STATUS = exports.GET_DRAW_TOTAL_MONTHLY_PAYMENT = exports.GET_DRAW_ELIGIBILITY = exports.GET_DRAW_ELIGIBILITIES = exports.GET_ACH_ACCOUNTS = exports.DOWNLOAD_SERVICING_DOCUMENT = exports.DELETE_ACH_ACCOUNT = exports.ACTIVATE_LOAN = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reduxActions = require("redux-actions");

var _ajax = require("./ajax");

var _httpActions = require("./http-actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ACTIVATE_LOAN = 'ACTIVATE_SERVICING_LOAN';
exports.ACTIVATE_LOAN = ACTIVATE_LOAN;
var GET_USER_LOAN_STATUSES = 'GET_SERVICING_USER_LOAN_STATUSES';
exports.GET_USER_LOAN_STATUSES = GET_USER_LOAN_STATUSES;
var GET_LOAN_STATUS = 'GET_SERVICING_LOAN_STATUS';
exports.GET_LOAN_STATUS = GET_LOAN_STATUS;
var GET_TRANSACTIONS = 'GET_SERVICING_TRANSACTIONS';
exports.GET_TRANSACTIONS = GET_TRANSACTIONS;
var GET_ACH_ACCOUNTS = 'GET_SERVICING_ACH_ACCOUNTS';
exports.GET_ACH_ACCOUNTS = GET_ACH_ACCOUNTS;
var SAVE_ACH_ACCOUNT = 'SAVE_SERVICING_ACH_ACCOUNT';
exports.SAVE_ACH_ACCOUNT = SAVE_ACH_ACCOUNT;
var DELETE_ACH_ACCOUNT = 'DELETE_SERVICING_ACH_ACCOUNT';
exports.DELETE_ACH_ACCOUNT = DELETE_ACH_ACCOUNT;
var SAVE_PAYMENT = 'SAVE_SERVICING_PAYMENT';
exports.SAVE_PAYMENT = SAVE_PAYMENT;
var UPDATE_AUTOPAY = 'UPDATE_SERVICING_AUTOPAY';
exports.UPDATE_AUTOPAY = UPDATE_AUTOPAY;
var GET_DRAW_ELIGIBILITIES = 'GET_SERVICING_DRAW_ELIGIBILITIES';
exports.GET_DRAW_ELIGIBILITIES = GET_DRAW_ELIGIBILITIES;
var GET_DRAW_ELIGIBILITY = 'GET_SERVICING_DRAW_ELIGIBILITY';
exports.GET_DRAW_ELIGIBILITY = GET_DRAW_ELIGIBILITY;
var SAVE_NEW_DRAW = 'SAVE_SERVICING_NEW_DRAW';
exports.SAVE_NEW_DRAW = SAVE_NEW_DRAW;
var GET_DRAW_TOTAL_MONTHLY_PAYMENT = 'GET_SERVICING_DRAW_TOTAL_MONTHLY_PAYMENT';
exports.GET_DRAW_TOTAL_MONTHLY_PAYMENT = GET_DRAW_TOTAL_MONTHLY_PAYMENT;
var GET_SERVICING_DOCUMENTS = 'GET_SERVICING_DOCUMENTS';
exports.GET_SERVICING_DOCUMENTS = GET_SERVICING_DOCUMENTS;
var DOWNLOAD_SERVICING_DOCUMENT = 'DOWNLOAD_SERVICING_DOCUMENT';
exports.DOWNLOAD_SERVICING_DOCUMENT = DOWNLOAD_SERVICING_DOCUMENT;
var CONTEXT = '/provenance/borrower/servicing/v2';
var activateLoan = (0, _reduxActions.createAction)(ACTIVATE_LOAN);
exports.activateLoan = activateLoan;

var getUserLoanStatuses = function getUserLoanStatuses() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxGet)(GET_USER_LOAN_STATUSES, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/loanStatus")));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getUserLoanStatuses = getUserLoanStatuses;

var getLoanStatus = function getLoanStatus(uuid) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxGet)(GET_LOAN_STATUS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/loanStatus/").concat(uuid)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.getLoanStatus = getLoanStatus;

var getTransactions = function getTransactions(uuid) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxGet)(GET_TRANSACTIONS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/transactions/").concat(uuid)));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.getTransactions = getTransactions;

var getAchAccounts = function getAchAccounts(uuid) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", (0, _ajax.ajaxGet)(GET_ACH_ACCOUNTS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/achAccount/").concat(uuid)));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
}; // { uuid, autopayEnabled, disbursement, autopayAmount, accountType, accountHolderName, accountNumber, routingNumber }


exports.getAchAccounts = getAchAccounts;

var saveAchAccount = function saveAchAccount(uuid, data) {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", (0, _ajax.ajaxPost)(SAVE_ACH_ACCOUNT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/achAccount/").concat(uuid), data));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};

exports.saveAchAccount = saveAchAccount;

var deleteAchAccount = function deleteAchAccount(uuid, achAccountUuid) {
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(dispatch) {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", (0, _ajax.ajaxDelete)(DELETE_ACH_ACCOUNT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/achAccount/").concat(uuid, "/").concat(achAccountUuid), null, {
                assetId: uuid
              }));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
}; // { assetId, effectiveDate, achAccountUUID, amount, message }


exports.deleteAchAccount = deleteAchAccount;

var savePayment = function savePayment(data) {
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(dispatch) {
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", (0, _ajax.ajaxPost)(SAVE_PAYMENT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/payment/"), data));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
}; // { autopayEnabled, autopayAmount?, autopayAccountUuid? }


exports.savePayment = savePayment;

var updateAutopay = function updateAutopay(uuid, data) {
  return /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(dispatch) {
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", (0, _ajax.ajaxPut)(UPDATE_AUTOPAY, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/achAccount/").concat(uuid, "/autopay"), _objectSpread(_objectSpread({}, data), {}, {
                assetId: uuid
              })));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};

exports.updateAutopay = updateAutopay;

var getDrawEligibilities = function getDrawEligibilities() {
  return /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(dispatch) {
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", (0, _ajax.ajaxGet)(GET_DRAW_ELIGIBILITIES, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/draw/eligibility/borrower")));

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
};

exports.getDrawEligibilities = getDrawEligibilities;

var getDrawEligibility = function getDrawEligibility(uuid) {
  return /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(dispatch) {
      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", (0, _ajax.ajaxGet)(GET_DRAW_ELIGIBILITY, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/draw/eligibility/").concat(uuid)));

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x10) {
      return _ref10.apply(this, arguments);
    };
  }();
}; // DrawRequest: { parentUUID, amount, disbursementAccountUuid, autopayAccountUuid?, autopayEnabled }


exports.getDrawEligibility = getDrawEligibility;

var saveNewDraw = function saveNewDraw(data) {
  return /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(dispatch) {
      return _regenerator.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", (0, _ajax.ajaxPost)(SAVE_NEW_DRAW, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/draw"), data));

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function (_x11) {
      return _ref11.apply(this, arguments);
    };
  }();
};

exports.saveNewDraw = saveNewDraw;

var getDrawTotalMonthlyPayment = function getDrawTotalMonthlyPayment(uuid, amount) {
  return /*#__PURE__*/function () {
    var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(dispatch) {
      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", (0, _ajax.ajaxGet)(GET_DRAW_TOTAL_MONTHLY_PAYMENT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/totalPayment/").concat(uuid, "?amount=").concat(amount), null, {
                uuid: uuid,
                amount: amount
              }));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function (_x12) {
      return _ref12.apply(this, arguments);
    };
  }();
};
/**
 * Includes statements, documents, and notices.
 *
 * @param {Object} data
 * example:
 * {
 *   "assetId": "29bdc2c1-5958-492e-8e2d-56fed3f2d160",
 *   "docTypes": ["SERVICINGSTATEMENT"]
 * }
 *
 * Providing a specific type will filter by that type.
 * Providing no doc types will just give everything whitelisted.
 */


exports.getDrawTotalMonthlyPayment = getDrawTotalMonthlyPayment;

var getServicingDocuments = function getServicingDocuments(data) {
  return /*#__PURE__*/function () {
    var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(dispatch) {
      return _regenerator.default.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", (0, _ajax.ajaxPost)(GET_SERVICING_DOCUMENTS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/fido/all"), data));

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function (_x13) {
      return _ref13.apply(this, arguments);
    };
  }();
};
/**
 * Download a statement, document, or notice.
 *
 * @param {*} applicationUuid
 * @param {*} fidoUuid
 * @param {*} contentDisposition
 */


exports.getServicingDocuments = getServicingDocuments;

var downloadServicingDocument = function downloadServicingDocument(applicationUuid, fidoUuid) {
  var contentDisposition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'inline';
  return /*#__PURE__*/function () {
    var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(dispatch) {
      return _regenerator.default.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", (0, _ajax.ajaxGet)(DOWNLOAD_SERVICING_DOCUMENT, dispatch, // eslint-disable-next-line
              "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/fido/download/").concat(applicationUuid, "/").concat(fidoUuid, "?contentDisposition=").concat(contentDisposition), {
                responseType: 'arraybuffer'
              }));

            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function (_x14) {
      return _ref14.apply(this, arguments);
    };
  }();
};

exports.downloadServicingDocument = downloadServicingDocument;